import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { IoArrowBackOutline } from "react-icons/io5";
import axios from "axios"; // Import axios
import "../css/Charts.css";
import "../css/mainhome.css";

const API_BASE_URL = "https://admin.gama567app.net/api/v1";
const REFRESH_INTERVAL_MS = 2000;

export default function ChartDetail() {
  // Get both the gameId and chartName from the URL
  const { gameType = "game", gameId, chartName = "" } = useParams();
  const navigate = useNavigate();
  
  // Add state for data, loading, and errors
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Make sure we have a gameId before fetching
    if (!gameId) return;

    let isMounted = true;

    const fetchData = async (showLoader = false) => {
      if (showLoader) {
        setLoading(true);
      }
      setError(null);
      try {
        const token = localStorage.getItem("accessToken");
        const response = await axios.post(
          `${API_BASE_URL}/table-chart?_=${Date.now()}`,
          {
            gameId: parseInt(gameId, 10), // Send the gameId from the URL
            gameType
          },
          {
            headers: {
              "Authorization": `Bearer ${token}`,
              "Content-Type": "application/json",
              "deviceId": "qwert",
              "deviceName": "sm2233",
              "accessStatus": "1",
            },
          }
        );
console.log(response);
        if (!isMounted) return;
        if (response.data.status && Array.isArray(response.data.info)) {
          setData(response.data.info);
        } else if (Array.isArray(response.data.info)) {
          setData([]);
        } else {
          throw new Error(response.data.msg || "Failed to fetch chart data.");
        }
      } catch (err) {
        if (!isMounted) return;
        setError(err.message);
        console.error("Chart detail fetch error:", err);
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchData(true);
    const intervalId = window.setInterval(() => fetchData(false), REFRESH_INTERVAL_MS);
    const handleFocus = () => fetchData(false);
    window.addEventListener("focus", handleFocus);

    return () => {
      isMounted = false;
      window.clearInterval(intervalId);
      window.removeEventListener("focus", handleFocus);
    };
  }, [gameId, gameType]); // Re-run the fetch if the chart changes

  return (
    <div className="mainhome-screen-wrapper">
      <div className="charts-header screen-header">
        <button className="back-btn" onClick={() => navigate(-1)}>
          <IoArrowBackOutline size={24} />
        </button>
        {/* Decode the URL slug back into a readable title */}
        <h2>{chartName.replace(/-/g, ' ').toUpperCase()}</h2>
      </div>

      <div className="chart-table-container screen-content">
        <div className="chart-table-header">
          <span>Date</span>
          <span>Open</span>
          <span>Jodi</span>
          <span>Close</span>
        </div>

        {loading && <p className="chart-message">Loading chart...</p>}
        {error && <p className="chart-message error">{error}</p>}
        {!loading && !error && data.length === 0 && (
            <p className="chart-message">No chart data available.</p>
        )}

        <div className="chart-table-body">
          {data.map((row, idx) => (
            <div key={idx} className="chart-row">
              <span>{row.date}</span>
              <span>{row.open}</span>
              {/* The API response uses 'digit' for the Jodi value */}
              <span className="jodi">{row.digit}</span>
              <span>{row.close}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
